/**
 * « Filtres récents » du panneau latéral : les derniers filtres appliqués,
 * mémorisés dans le navigateur du visiteur et re-cliquables.
 *
 * Desktop uniquement — le masquage est fait en CSS, pas ici : le panneau est un
 * seul et même nœud aux deux tailles, et une media query suit le redimensionnement
 * sans qu'on ait à l'écouter.
 *
 * Comment les paramètres d'un filtre sont retrouvés : chaque badge actif porte
 * l'URL de la page SANS lui (son lien « retirer »). La différence entre l'URL
 * courante et celle-là donne donc exactement les paires (clé, valeur) de ce
 * filtre — y compris quand il en a six, comme une pastille « 500+ Wh », que le
 * thème n'affiche pourtant que comme un badge unique. Aucune règle à maintenir
 * en double : la liste vient du rendu serveur.
 *
 * Le stockage est best-effort : localStorage lève en navigation privée ou quand
 * les données de site sont bloquées, et peut revenir vide. Toute lecture et
 * toute écriture sont donc gardées, et l'absence de mémoire se traduit par une
 * section masquée, jamais par une erreur.
 */
(function () {
  'use strict';

  var CLE = 'mint:filtres-recents';
  var CLE_REPLI = 'mint:filtres-recents-replie';
  var MAX = 8;

  function lire() {
    try {
      var brut = window.localStorage.getItem(CLE);
      if (!brut) return [];
      var parse = JSON.parse(brut);
      return Array.isArray(parse) ? parse : [];
    } catch (e) {
      return [];
    }
  }

  function ecrire(liste) {
    try {
      window.localStorage.setItem(CLE, JSON.stringify(liste.slice(0, MAX)));
    } catch (e) {
      /* quota, navigation privée, données de site bloquées : on n'insiste pas */
    }
  }

  function estReplie() {
    try {
      return window.localStorage.getItem(CLE_REPLI) === '1';
    } catch (e) {
      return false;
    }
  }

  function memoriserRepli(replie) {
    try {
      window.localStorage.setItem(CLE_REPLI, replie ? '1' : '0');
    } catch (e) {
      /* idem */
    }
  }

  /**
   * Les paires (clé, valeur) que ce badge apporte : présentes dans l'URL
   * courante, absentes de son URL de retrait.
   */
  function paramsDuBadge(lien) {
    var courant = new URLSearchParams(window.location.search);
    var sansLui;
    try {
      sansLui = new URL(lien.href, window.location.origin).searchParams;
    } catch (e) {
      return [];
    }
    var restants = [];
    sansLui.forEach(function (v, k) {
      restants.push(k + '=' + v);
    });
    var paires = [];
    courant.forEach(function (v, k) {
      if (k.indexOf('filter.') !== 0) return;
      var i = restants.indexOf(k + '=' + v);
      if (i !== -1) {
        // consommé : un même couple répété ne doit pas s'annuler deux fois
        restants.splice(i, 1);
        return;
      }
      paires.push([k, v]);
    });
    return paires;
  }

  function enregistrerLesFiltresCourants() {
    var badges = document.querySelectorAll('.tag-list--active-tags .tag:not(.tag--clear-all)');
    if (!badges.length) return;

    var liste = lire();
    var vus = {};

    badges.forEach(function (badge) {
      var lien = badge.querySelector('a');
      var texte = (badge.querySelector('.tag__text') || badge).textContent.trim().replace(/\s+/g, ' ');
      if (!lien || !texte) return;
      // Le panneau et la barre rendent les mêmes badges : on ne garde qu'un
      // exemplaire par libellé pour ce passage.
      if (vus[texte]) return;
      vus[texte] = true;

      var paires = paramsDuBadge(lien);
      if (!paires.length) return;

      var entree = { label: texte, params: paires };
      var signature = JSON.stringify(paires);
      liste = liste.filter(function (e) {
        return JSON.stringify(e.params) !== signature;
      });
      liste.unshift(entree);
    });

    ecrire(liste);
  }

  /**
   * Une pastille cochée n'agit pas tout de suite : elle dépose ses paires dans
   * le formulaire du panneau, que « Appliquer les filtres » sérialise en
   * FormData (theme.js, #FilterDrawerApply). C'est le même parcours que les
   * autres filtres du panneau — sélectionner, puis appliquer.
   *
   * Le dépôt se fait en <input type="hidden"> INJECTÉS dans le formulaire : la
   * pastille, elle, vit au-dessus de lui (sous les badges actifs) et ne serait
   * pas sérialisée là où elle est. Le formulaire n'ayant pas d'id, l'attribut
   * `form` d'un champ déporté n'est pas utilisable.
   */
  function formulaireDuPanneau() {
    return document.querySelector('#FilterDrawer .filter-form');
  }

  function deposer(index, entree) {
    var form = formulaireDuPanneau();
    if (!form) return;
    retirer(index);
    entree.params.forEach(function (paire) {
      var champ = document.createElement('input');
      champ.type = 'hidden';
      champ.name = paire[0];
      champ.value = paire[1];
      champ.setAttribute('data-recent-hidden', String(index));
      form.appendChild(champ);
    });
  }

  function retirer(index) {
    var form = formulaireDuPanneau();
    if (!form) return;
    form.querySelectorAll('[data-recent-hidden="' + index + '"]').forEach(function (n) {
      n.parentNode.removeChild(n);
    });
  }

  /**
   * Paramètres de filtre RÉELLEMENT proposés par la collection courante, lus sur le rendu
   * serveur : les champs du panneau et les pastilles de la barre. Aucune liste à maintenir.
   */
  function parametresDisponibles() {
    var noms = Object.create(null);
    var champs = document.querySelectorAll('#FilterDrawer .filter-form [name^="filter."]');
    Array.prototype.forEach.call(champs, function (champ) {
      // Les champs déposés par une pastille récente sont exclus : ils se valideraient eux-mêmes.
      if (champ.hasAttribute('data-recent-hidden')) return;
      noms[champ.name] = true;
    });
    var pastilles = document.querySelectorAll('[data-filter-id]');
    Array.prototype.forEach.call(pastilles, function (noeud) {
      var id = noeud.getAttribute('data-filter-id');
      if (id) noms[id] = true;
    });
    return noms;
  }

  /**
   * Un filtre mémorisé sur une collection n'existe pas forcément sur la suivante : un filtre
   * de couple moteur reporté sur des vélos de route ne peut donner que zéro résultat, et
   * Shopify renvoie alors `collection.filters` VIDE — plus une seule commande à l'écran pour
   * revenir en arrière (mesuré le 2026-09-16 sur /collections/velo-route-cervelo-reconditionne :
   * 0 produit, 0 pastille, 0 case, contre 4 / 5 / 7 sans le filtre). On ne propose donc que
   * les entrées dont TOUS les paramètres existent ici.
   */
  function estApplicable(entree, disponibles) {
    if (!entree || !entree.params || !entree.params.length) return false;
    for (var i = 0; i < entree.params.length; i++) {
      if (!disponibles[entree.params[i][0]]) return false;
    }
    return true;
  }

  function peindre() {
    var bloc = document.querySelector('[data-filter-recent]');
    var liste = document.querySelector('[data-filter-recent-list]');
    if (!bloc || !liste) return;

    var entrees = lire();
    if (!entrees.length) {
      bloc.hidden = true;
      return;
    }

    /*
     * L'index d'origine est conservé : `deposer` et `retirer` relisent l'entrée par sa
     * position dans le STOCKAGE (`lire()[index]`). Renuméroter à l'affichage ferait appliquer
     * un filtre pour un autre dès qu'une entrée est écartée.
     */
    var disponibles = parametresDisponibles();
    var retenues = [];
    entrees.forEach(function (entree, index) {
      if (estApplicable(entree, disponibles)) retenues.push({ entree: entree, index: index });
    });
    if (!retenues.length) {
      bloc.hidden = true;
      return;
    }

    liste.textContent = '';
    retenues.slice(0, MAX).forEach(function (retenue) {
      var entree = retenue.entree;
      var index = retenue.index;
      // Mêmes classes que les pastilles de filtre : l'état coché est peint par
      // filter-bucket.css, via son sélecteur adjacent input:checked + label.
      var label = document.createElement('label');
      label.className = 'filter-bucket-btn';

      var input = document.createElement('input');
      input.type = 'checkbox';
      input.className = 'filter-bucket-btn__input';
      input.setAttribute('data-recent-index', String(index));

      var span = document.createElement('span');
      span.className = 'filter-bucket-btn__label';
      span.textContent = entree.label;

      label.appendChild(input);
      label.appendChild(span);
      liste.appendChild(label);
    });

    bloc.hidden = false;
    appliquerRepli(bloc, estReplie());
  }

  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-recent-index]');
    if (!input) return;
    var index = parseInt(input.getAttribute('data-recent-index'), 10);
    var entree = lire()[index];
    if (!entree) return;
    if (input.checked) deposer(index, entree);
    else retirer(index);
  });

  function appliquerRepli(bloc, replie) {
    var trigger = bloc.querySelector('[data-filter-recent-toggle]');
    var contenu = bloc.querySelector('[data-filter-recent-list]');
    if (!trigger || !contenu) return;
    trigger.setAttribute('aria-expanded', replie ? 'false' : 'true');
    contenu.hidden = replie;
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-filter-recent-toggle]');
    if (!trigger) return;
    e.preventDefault();
    e.stopPropagation();
    var bloc = trigger.closest('[data-filter-recent]');
    var replie = trigger.getAttribute('aria-expanded') === 'true';
    memoriserRepli(replie);
    appliquerRepli(bloc, replie);
  });

  function demarrer() {
    enregistrerLesFiltresCourants();
    peindre();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', demarrer);
  } else {
    demarrer();
  }

  // Le contenu du panneau est remplacé à chaque filtrage (theme.js,
  // onReplaceAjaxContent) : la liste peinte ici disparaît avec lui.
  document.addEventListener('collection:reloaded', demarrer);
})();
